<app-toast [message]="toast.message"></app-toast>

<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <div class="card">
      <h4 class="card-header">PDF</h4>
      <div class="card-body">

        <p>
          Execute Optical Character Recognition (<a target="_blank" href="https://en.wikipedia.org/wiki/Optical_character_recognition">OCR</a>) on scanned non searchable PDF.<br>
          Max 25MB and 100 pages per file. Two files will be generated with two different OCR methods.<br>
          The file will also be saved in the database, making its content appear on the <a href="/">Search page</a>.
        </p>

        <div class="custom-file mb-2">
          <input type="file" class="custom-file-input" id="custom-file" accept="application/pdf" multiple (change)="selectFiles($event)" />
          <label class="custom-file-label" for="custom-file">Choose file</label>
        </div>

        @for (progressInfo of progressInfos; track progressInfo) {
          <div class="mb-2">
            <span>{{progressInfo.fileName}}</span>
            <div class="progress">
              <div class="progress-bar progress-bar-striped bg-success"
                [ngClass]="{ 'bg-danger': uploadError }"
                role="progressbar"
                attr.aria-valuenow="{{ progressInfo.value }}"
                aria-valuemin="0"
                aria-valuemax="100"
                [ngStyle]="{ width: progressInfo.value + '%' }">
                {{progressInfo.value}}%
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="card mt-2">
      <h4 class="card-header">
        Files converted <small class="text-muted me-1">(last {{daysBack}} days)</small> <app-spinner [condition]="isLoading.converted"></app-spinner>
        <button class="btn btn-primary btn-sm float-end" (click)="getFiles('converted')"
          data-bs-toggle="tooltip" data-placement="top" title="Refresh">
          <i class="fa fa-refresh"></i>
        </button>
      </h4>
      <div class="card-body">
        <table class="table table-bordered" [ngClass]="{ 'disabled': isLoading.converted }">
          <thead class="thead-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col" class="d-none d-lg-table-cell">Size</th>
              <th scope="col" class="d-none d-lg-table-cell">Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            @if (!isLoading.converted && convertedFiltered.length === 0) {
              <tr>
                <td>
                  There are no items in the last {{daysBack}} days. <a [routerLink]="null" (click)="daysBack = 90; getAllFiles()">Show all</a>.
                </td>
              </tr>
            }
            @for (file of convertedFiltered; track file) {
              <tr>
                @if (file.name.length <= 20) {
                  <td>
                    <a [href]="file.url" target="_blank">{{file.name}}</a>
                  </td>
                }
                @if (file.name.length > 20) {
                  <td>
                    <a class="text-break" [href]="file.url" target="_blank">
                      {{file.name}}
                    </a>
                  </td>
                }
                <td class="d-none d-lg-table-cell">{{file.size | fileSize}}</td>
                <td class="d-none d-lg-table-cell">{{file.date | date:'medium'}}</td>
                <td class="d-flex">
                  <button class="btn btn-sm btn-primary d-none d-lg-block" (click)="saveAs(file)"
                    data-bs-toggle="tooltip" data-placement="top" title="Download">
                    <i class="fa fa-download"></i>
                  </button>
                  @if (auth.loggedIn) {
                    <button class="btn btn-sm btn-danger ms-2" (click)="deleteFile(file.name, 'converted')"
                      data-bs-toggle="tooltip" data-placement="top" title="Delete">
                      <i class="fa fa-trash"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    @if (auth.loggedIn && auth.isAdmin) {
      <div class="card mt-2">
        <h4 class="card-header">
          Files uploaded <small class="text-muted me-1">(last {{daysBack}} days)</small> <app-spinner [condition]="isLoading.uploaded"></app-spinner>
          <button class="btn btn-primary btn-sm float-end" (click)="getFiles('uploaded')"
            data-bs-toggle="tooltip" data-placement="top" title="Refresh">
            <i class="fa fa-refresh"></i>
          </button>
        </h4>
        <div class="card-body">
          <table class="table table-bordered" [ngClass]="{ 'disabled': isLoading.uploaded }">
            <thead class="thead-light">
              <tr>
                <th scope="col">Name</th>
                <th scope="col" class="d-none d-lg-table-cell">Size</th>
                <th scope="col" class="d-none d-lg-table-cell">Date</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (!isLoading.uploaded && uploadedFiltered.length === 0) {
                <tr>
                  <td>
                    There are no items in the last {{daysBack}} days. <a [routerLink]="null" (click)="daysBack = 90; getAllFiles()">Show all</a>.
                  </td>
                </tr>
              }
              @for (file of uploadedFiltered; track file) {
                <tr>
                  @if (file.name.length <= 20) {
                    <td>
                      <a [href]="file.url" target="_blank">{{file.name}}</a>
                    </td>
                  }
                  @if (file.name.length > 20) {
                    <td>
                      <a class="text-break" [href]="file.url" target="_blank">
                        {{file.name}}
                      </a>
                    </td>
                  }
                  <td class="d-none d-lg-table-cell">{{file.size | fileSize}}</td>
                  <td class="d-none d-lg-table-cell">{{file.date | date:'medium'}}</td>
                  <td class="d-flex">
                    <button class="btn btn-sm btn-primary d-none d-lg-block" (click)="saveAs(file)"
                      data-bs-toggle="tooltip" data-placement="top" title="Download">
                      <i class="fa fa-download"></i>
                    </button>
                    @if (auth.isAdmin) {
                      <button class="btn btn-sm btn-danger ms-2" (click)="deleteFile(file.name, 'uploaded')"
                        data-bs-toggle="tooltip" data-placement="top" title="Delete">
                        <i class="fa fa-trash"></i>
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
</div>